import React, { Suspense } from "react";
import { Spin } from "antd";
const AccountTemplate = React.lazy(
  () => import("../../../../modules/Accounts/components/AccountTemplate")
);

const AccountCreatePage = () => (
  <Suspense fallback={<Spin />}>
    <AccountTemplate type="create" />
  </Suspense>
);

export default AccountCreatePage;
